import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

const Icon = styled(FontAwesomeIcon)`
  padding-right: 5px;
`

export { Icon }
